module.exports = __webpack_public_path__ + "static/img/left-top-row-2.d6580900.webp";